module.exports = __webpack_public_path__ + "img/mob_img_compare_phone.89f2c8ce.png";